import React, { memo } from 'react';
import { Check, X } from 'lucide-react';
export function ForYouSection() {
  return <section className="w-full bg-white py-16 md:py-24 px-4" data-id="element-96">
      <div className="max-w-4xl mx-auto" data-id="element-97">
        <div className="grid md:grid-cols-2 gap-12 items-start" data-id="element-98">
          {/* Yes Column */}
          <div className="bg-stone-50 p-8 rounded-2xl border border-stone-100" data-id="element-99">
            <h2 className="text-2xl font-serif font-bold text-stone-900 mb-6 flex items-center" data-id="element-100">
              <span className="bg-emerald-100 text-emerald-800 p-2 rounded-full mr-3" data-id="element-101">
                <Check className="w-5 h-5" data-id="element-102" />
              </span>
              Esto es para vos si...
            </h2>
            <ul className="space-y-4" data-id="element-103">
              {['Sos hijo/a y te convertiste en el “centro de control” sin pedirlo', 'Estás cansado/a de buscar información en 30 chats, 6 papelitos y tu memoria', 'Te da miedo que algo pase y nadie sepa qué hacer', 'Querés delegar… pero cada intento termina en confusión o pelea'].map((item, i) => <li key={i} className="flex items-start text-stone-700" data-id="element-104">
                  <span className="mr-3 mt-1.5 w-1.5 h-1.5 bg-emerald-600 rounded-full flex-shrink-0" data-id="element-105" />
                  {item}
                </li>)}
            </ul>
          </div>

          {/* No Column */}
          <div className="p-8" data-id="element-106">
            <h2 className="text-2xl font-serif font-bold text-stone-400 mb-6 flex items-center" data-id="element-107">
              <span className="bg-stone-100 text-stone-400 p-2 rounded-full mr-3" data-id="element-108">
                <X className="w-5 h-5" data-id="element-109" />
              </span>
              No es para vos si...
            </h2>
            <p className="text-stone-600 mb-4" data-id="element-110">
              Buscás diagnóstico médico, tratamiento o asesoramiento legal.
            </p>
            <p className="text-stone-800 font-medium italic border-l-4 border-stone-200 pl-4" data-id="element-111">
              Esto es organización real para vida real.
            </p>
          </div>
        </div>
      </div>
    </section>;
}